import { combineReducers } from '@reduxjs/toolkit';
import authSliceReducer from './slices/authSlice';
import appSliceReducer from './slices/appSlice';
import { usersApi } from '@api/users';
import { rolesApi } from '@api/roles';
import { dashbordsApi } from '@api/dashboards';
import { permissionsApi } from '@api/permissions';
import { organisationsApi } from '@api/organisations';
import { chatsApi } from '@api/chats';
import { customerCreditBalanceApi } from '@api/creditBalance';

export const rootReducer = combineReducers({
    auth: authSliceReducer,
    app: appSliceReducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [dashbordsApi.reducerPath]: dashbordsApi.reducer,
    [permissionsApi.reducerPath]: permissionsApi.reducer,
    [chatsApi.reducerPath]: chatsApi.reducer,
    [organisationsApi.reducerPath]: organisationsApi.reducer,
    [customerCreditBalanceApi.reducerPath]: customerCreditBalanceApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
